import React from "react";

import Headline from "../../../../../shared/Headline";
import Section from "../../../../../shared/Section";
import ContactData from "./ContactData";
import DeliveryAddress from "./DeliveryAddress";

const BillingDeliveryForm = () => {
    return (
        <div>
            <Section withMargin>
                <Headline>Rechnungadresse</Headline>
            </Section>
            <Section withMargin>
                <ContactData />
            </Section>
            <Section withMargin>
                <DeliveryAddress />
            </Section>
        </div>
    );
};

export default BillingDeliveryForm;
